module.exports = __webpack_public_path__ + "img/facebook-icon.7660c3b0.svg";